import { NavItem } from '@billy/design-system'
import reduce from 'lodash/reduce'

import { SelectableProductAccount } from '../../../query-api'
import { ProductAccountValue } from '../types/productAccountValue'
import { getDisplayTitle } from './getDisplayTitle'

const getItem = (account: SelectableProductAccount): NavItem<ProductAccountValue> => {
  const displayTitle = getDisplayTitle(account)
  const searchKeywords = [account.name]

  if (account.accountNo) {
    searchKeywords.push(account.accountNo.toString())
  }

  return {
    id: account.id,
    children: displayTitle,
    searchKeywords,
    value: {
      ...account,
      displayData: {
        title: displayTitle,
      },
    },
  }
}

export const getItems = (accounts: SelectableProductAccount[]): NavItem<ProductAccountValue>[] =>
  reduce(
    accounts,
    (result, account) => {
      result.push(getItem(account))
      return result
    },
    [] as NavItem<ProductAccountValue>[],
  )
